<template>
    <hr class="z-separator" :style="separatorStyle">
</template>

<script>
export default {
    name: 'zoezi-separator',

    zoezi: {
        title: 'Separator',
        icon: 'mdi-arrow-expand-vertical'
    },

    props: {
        width: {
            title: 'Width',
            type: Number
        },
        height: {
            title: 'Height',
            type: Number,
            default: 1
        },
        color: {
            title: 'Color',
            type: String,
            fulltype: 'color'
        },
    },
    computed: {
        separatorStyle(){
            return {
                'background-color' : this.color ? this.$root.colorToHex(this.color) : 'transparent',
                height: this.height + 'px',
                width: this.width + 'px'
            }
        }
    },
}
</script>
